import store from '../store'
import { encode } from 'js-base64'
function appendQueryString(baseUrl, params) {
  // 判断基础URL中是否已经包含问号
  const hasQuestionMark = baseUrl.includes('?')

  // 构建参数字符串
  const paramString = Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&')

  // 拼接URL
  const fullUrl = hasQuestionMark ? `${baseUrl}&${paramString}` : `${baseUrl}?${paramString}`

  return fullUrl
}
// 需要拦截的域名或者链接
const urls = [process.env.NODE_ENV === 'development' ? 'test-form.ayundi.cn' : 'form.ayundi.cn']
document.addEventListener('click', function (event) {
  const target = event.target
  const targetUrl = target.getAttribute('href') || ''
  const find =
    target.tagName === 'A' && targetUrl && urls.some((item) => targetUrl.indexOf(item) !== -1)
  // 检查点击的元素是否为链接
  if (find) {
    // 阻止默认跳转行为
    event.preventDefault()

    // 处理外部链接的逻辑，例如弹出提示、记录日志等
    const params = {
      type: encode(3),
      id: encode(store.getters.userInfo.userId)
    }
    window.open(appendQueryString(targetUrl, params))
  }
})
